import { createBrowserRouter, RouterProvider, Outlet, Navigate } from 'react-router'
import Brand from '@/elements/Brand'
import Profile from '@/pages/Profile'
import Dashboard from '@/pages/Dashboard'
import ErrorFallback from '@/components/ErrorFallback'
import Button from '@/elements/Button'
import useAuthStore from '@/stores/authStore'
import { LogOut } from 'lucide-react'

const WrapperWithLogoAndLogout = () => {
  const { logout } = useAuthStore()

  return (
    <main className='container single'>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Brand styles={{ margin: '0 auto' }} />
        <Button variant='secondary' onClick={logout}>
          <LogOut />
          Log Out
        </Button>
      </div>
      <Outlet />
    </main>
  )
}

const anonRouter = createBrowserRouter([
  {
    element: <WrapperWithLogoAndLogout />,
    ErrorBoundary: ErrorFallback,
    children: [
      {
        path: 'profile/:id',
        element: <Profile />
      },
      {
        index: true,
        element: <Dashboard />,
        ErrorBoundary: ErrorFallback,
      },
      {
        path: '*',
        element: <Navigate replace to='/' />,
      }
    ]
  },
])

const Anon = () => <RouterProvider router={anonRouter} />

export default Anon
